import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';

// Where people land after deleting their account (they are signed out by then). Outside the
// signed-in area on purpose, so signing out can't redirect away from it. The heading takes focus
// so screen readers announce the outcome straight away. No toasts.
export default function AccountDeletedPage() {
  const headingRef = useRef(null);

  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <main className="min-h-screen bg-[#F8F7F5] flex items-center justify-center p-6">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 text-center shadow-sm">
        <div aria-hidden="true" className="mb-4 flex justify-center">
          <Logo className="h-14 w-14" color="#AFBB8B" />
        </div>
        <h1 ref={headingRef} tabIndex={-1} className="mpg-focus-ring text-2xl font-bold text-[#1F2814]">
          Your account has been deleted
        </h1>
        <p className="mt-4 text-base leading-7 text-[#1F2814]">
          Your recipes, meal plans, shopping lists, photos and login have all been removed.
          We&apos;ve also sent a confirmation to your email.
        </p>
        <p className="mt-3 text-base leading-7 text-[#5C5F6A]">
          Thanks for cooking with MealPlan Genie. You&apos;re always welcome back.
        </p>
        <Link
          to="/auth/signin"
          replace
          className="mpg-focus-ring mt-6 inline-flex min-h-[48px] items-center justify-center rounded-full bg-[#AFBB8B] px-6 font-medium text-[#1F2814] hover:bg-[#9AA876]"
        >
          Go to the sign-in page
        </Link>
      </div>
    </main>
  );
}
